import { PermissionCheckProps } from '../types'

export enum LegacyPermission {
  SALE = 'sale',
  ONLY = 'only',
  REFUND = 'refund',
  UNREF_REFUND = 'unreferenced_refund',
  VOID = 'void',
  CAPTURE = 'capture',
  CAN_PROCESS_ACH_REFERENCED_REFUNDS = 'can_process_ach_referenced_refunds',
  CAN_PROCESS_ACH_SALES = 'can_process_ach_sales',
  CAN_PROCESS_ACH_SETTLEMENT = 'can_process_ach_settlement',
  CAN_PROCESS_ACH_UNREFERENCED_REFUNDS = 'can_process_ach_unreferenced_refunds',
  CAN_PROCESS_ACH_VOID = 'can_process_ach_voids',
  CAN_PROCESS_CAPTURES = 'can_process_captures',
  CAN_PROCESS_FORCED_SALES = 'can_process_forced_sales',
  CAN_PROCESS_REFERENCED_REFUNDS = 'can_process_referenced_refunds',
  CAN_PROCESS_SALES = 'can_process_sales',
  CAN_PROCESS_SETTLEMENT = 'can_process_settlement',
  CAN_PROCESS_UNREFERENCED_REFUNDS = 'can_process_unreferenced_refunds',
  CAN_PROCESS_VOID = 'can_process_voids',
  CAN_VIEW_ACH_TRANSACTIONS = 'can_view_ach_transactions',
  CAN_VIEW_RESELLER_STATEMENTS = 'can_view_reseller_statements',
  CAN_VIEW_TRANSACTIONS = 'can_view_transactions',
  CAN_MANAGE_ACH_ADMIN = 'can_manage_ach_admin',
  CAN_MANAGE_CONTACTS_ADMIN = 'can_manage_contacts_admin',
  CAN_MANAGE_HELP_ADMIN = 'can_manage_help_admin',
  CAN_MANAGE_STATEMENTS_ADMIN = 'can_manage_statements_admin',
  CAN_CREATE_MERCHANTS_RESELLER = 'can_create_merchants_reseller',
  CAN_MANAGE_MERCHANT_USERS_RESELLER = 'can_manage_merchant_users_reseller',
  CAN_MANAGE_MERCHANTS_RESELLER = 'can_manage_merchants_reseller',
  CAN_MANAGE_RESELLER_USERS_RESELLER = 'can_manage_reseller_users_reseller',
  CAN_MODIFY_MERCHANTS_RESELLER = 'can_modify_merchants_reseller',
  HAS_READ_ONLY_MERCHANT_ACCESS_RESELLER = 'has_read_only_merchant_access_reseller',
  HAS_READ_ONLY_RESELLER_ACCESS_RESELLER = 'has_read_only_reseller_access_reseller',
  BILLED_BY_PAYTRACE = 'billed_by_paytrace',
  IS_MERCHANT = 'is_merchant',
  HAS_RECURRING = 'has_recurring',
  HAS_INTEGRATION = 'has_integration',
  HAS_SHOPPING_CART = 'has_shopping_cart',
  IS_BASIC = 'is_basic',
  IS_PROFESSIONAL = 'is_professional',
  IS_CASH_ADVANCE = 'is_cash_advance',
  PROCESSOR_NETWORK = 'processor_network',
  CAN_HANDLE_LEVEL_3 = 'can_handle_level_3',
  IS_NGT_METIS_MERCHANT = 'is_ngt_metis_merchant',
  HAS_CHECK_ACH = 'has_check_ach',
}
interface LookupKey {
  [key: string]: {
    [key: string]: string;
  };
}

const lookupKey: LookupKey = {
  [LegacyPermission.SALE]: { user: 'can_process_sales' },
  [LegacyPermission.ONLY]: { user: 'can_process_sales' },
  [LegacyPermission.REFUND]: { user: 'can_process_referenced_refunds' },
  [LegacyPermission.UNREF_REFUND]: { user: 'can_process_unreferenced_refunds' },
  [LegacyPermission.VOID]: { user: 'can_process_voids' },
  [LegacyPermission.CAPTURE]: { user: 'can_process_captures' },
  [LegacyPermission.CAN_PROCESS_ACH_REFERENCED_REFUNDS]: { user: 'can_process_ach_referenced_refunds' },
  [LegacyPermission.CAN_PROCESS_ACH_SALES]: { user: 'can_process_ach_sales' },
  [LegacyPermission.CAN_PROCESS_ACH_SETTLEMENT]: { user: 'can_process_ach_settlement' },
  [LegacyPermission.CAN_PROCESS_ACH_UNREFERENCED_REFUNDS]: { user: 'can_process_ach_unreferenced_refunds' },
  [LegacyPermission.CAN_PROCESS_ACH_VOID]: { user: 'can_process_ach_voids' },
  [LegacyPermission.CAN_PROCESS_CAPTURES]: { user: 'can_process_captures' },
  [LegacyPermission.CAN_PROCESS_FORCED_SALES]: { user: 'can_process_forced_sales' },
  [LegacyPermission.CAN_PROCESS_REFERENCED_REFUNDS]: { user: 'can_process_referenced_refunds' },
  [LegacyPermission.CAN_PROCESS_SALES]: { user: 'can_process_sales' },
  [LegacyPermission.CAN_PROCESS_SETTLEMENT]: { user: 'can_process_settlement' },
  [LegacyPermission.CAN_PROCESS_UNREFERENCED_REFUNDS]: { user: 'can_process_unreferenced_refunds' },
  [LegacyPermission.CAN_PROCESS_VOID]: { user: 'can_process_voids' },
  [LegacyPermission.CAN_VIEW_ACH_TRANSACTIONS]: { user: 'can_view_ach_transactions' },
  [LegacyPermission.CAN_VIEW_RESELLER_STATEMENTS]: { user: 'can_view_reseller_statements' },
  [LegacyPermission.CAN_VIEW_TRANSACTIONS]: { user: 'can_view_transactions' },
  [LegacyPermission.CAN_MANAGE_ACH_ADMIN]: { user: 'can_manage_ach_admin' },
  [LegacyPermission.CAN_MANAGE_CONTACTS_ADMIN]: { user: 'can_manage_contacts_admin' },
  [LegacyPermission.CAN_MANAGE_HELP_ADMIN]: { user: 'can_manage_help_admin' },
  [LegacyPermission.CAN_MANAGE_STATEMENTS_ADMIN]: { user: 'can_manage_statements_admin' },
  [LegacyPermission.CAN_CREATE_MERCHANTS_RESELLER]: { user: 'can_create_merchants_reseller' },
  [LegacyPermission.CAN_MANAGE_MERCHANT_USERS_RESELLER]: { user: 'can_manage_merchant_users_reseller' },
  [LegacyPermission.CAN_MANAGE_MERCHANTS_RESELLER]: { user: 'can_manage_merchants_reseller' },
  [LegacyPermission.CAN_MANAGE_RESELLER_USERS_RESELLER]: { user: 'can_manage_reseller_users_reseller' },
  [LegacyPermission.CAN_MODIFY_MERCHANTS_RESELLER]: { user: 'can_modify_merchants_reseller' },
  [LegacyPermission.HAS_READ_ONLY_MERCHANT_ACCESS_RESELLER]: { user: 'has_read_only_merchant_access_reseller' },
  [LegacyPermission.HAS_READ_ONLY_RESELLER_ACCESS_RESELLER]: { user: 'has_read_only_reseller_access_reseller' },
  [LegacyPermission.BILLED_BY_PAYTRACE]: { company: 'billed_by_paytrace' },
  [LegacyPermission.IS_MERCHANT]: { company: 'is_merchant' },
  [LegacyPermission.HAS_RECURRING]: { company: 'has_recurring' },
  [LegacyPermission.HAS_INTEGRATION]: { company: 'has_integration' },
  [LegacyPermission.HAS_SHOPPING_CART]: { company: 'has_shopping_cart' },
  [LegacyPermission.IS_BASIC]: { company: 'is_basic' },
  [LegacyPermission.IS_PROFESSIONAL]: { company: 'is_professional' },
  [LegacyPermission.IS_CASH_ADVANCE]: { company: 'is_cash_advance' },
  [LegacyPermission.PROCESSOR_NETWORK]: { company: 'processor_network' },
  [LegacyPermission.CAN_HANDLE_LEVEL_3]: { company: 'can_handle_level_3' },
  [LegacyPermission.IS_NGT_METIS_MERCHANT]: { company: 'is_ngt_metis_merchant' },
  [LegacyPermission.HAS_CHECK_ACH]: { company: 'has_check_ach' },
}
export function hasPermission ({ records, required_permissions, disallowed_permissions, do_admin_bypass = true }: PermissionCheckProps) {
  // required_permissions all the value should be true
  // disallowed_permissions all the value should be false
  if (records.user?.is_admin && do_admin_bypass) {
    return true
  }

  try {
    const hasAllRequired = required_permissions.every(auth_type => {
      const permission_map = lookupKey[auth_type]
      const key = Object.keys(permission_map)[0]
      const value = permission_map[key]
      return records[key][value]
    })

    if (!hasAllRequired) {
      return false
    }

    if (disallowed_permissions && disallowed_permissions.length > 0) {
      const hasAnyDisallowed = disallowed_permissions.some(auth_type => {
        const permission_map = lookupKey[auth_type]
        const key = Object.keys(permission_map)[0]
        const value = permission_map[key]
        return records[key][value]
      }

      )
      if (hasAnyDisallowed) {
        return false
      }
    }
    return true
  } catch (e) {
    console.error(e)
    return false
  }
}
